import app from '../../forum/app';
import Modal, { IInternalModalAttrs } from '../../common/components/Modal';
import ForgotPasswordModal from './ForgotPasswordModal';
import SignUpModal from './SignUpModal';
import Button from '../../common/components/Button';
import LogInButtons from './LogInButtons';
import extractText from '../../common/utils/extractText';
import ItemList from '../../common/utils/ItemList';
import Stream from '../../common/utils/Stream';
import type Mithril from 'mithril';
import RequestError from '../../common/utils/RequestError';
import type { LoginParams } from '../../common/Session';
import AlertUtil from '../../forum/dianLiang/alertUtil';

export interface ILoginModalAttrs extends IInternalModalAttrs {
  data?: string;
  title?: string;
}

export default class AgreementModal<CustomAttrs extends ILoginModalAttrs = ILoginModalAttrs> extends Modal<CustomAttrs> {
  data!: string;
  titleTxt!: string;
  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);
    this.data = this.attrs.data || '';
    this.titleTxt = this.attrs.title || '';
  }

  className() {
    return 'AgreementModal Modal--medium';
  }

  title() {
    return this.titleTxt;
  }

  content() {
    return [<div className="Modal-body" style="color: var(--modal-bd-input-color);">{this.body()}{this.footer()}</div>];
  }

  body() {
    let text = this.data;
    // 将字符串映射转换为 JavaScript 对象
    const obj = JSON.parse(text);
    // 创建 Map 对象并初始化
    const map = new Map(Object.entries(obj));
    // 获取特定键的值
    let htmlContent = map.get(app.data.locale);
    return <div className='agreement-modal-content'>{m.trust(htmlContent)}</div>;
  }

  footer() {
    return (
      <>
        {/* <p className="LogInModal-forgotPassword">
          <a onclick={this.forgotPassword.bind(this)}>{app.translator.trans('core.forum.log_in.forgot_password_link')}</a>
        </p> */}
        <div className="Form-group">
          <Button className="Button Button--primary Button--block" onclick={() => app.modal.close()}>
            {app.translator.trans('dl-pay.forum.operation.accept')}
          </Button>
        </div>
      </>
    );
  }

  onerror(error: RequestError) {
    this.loading = false;
    AlertUtil.onWarn(app, error.responseText);
  }
}
